import SubdirectoryArrowRightIcon from '@mui/icons-material/SubdirectoryArrowRight';
import {
  Button,
  IconButton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
} from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";

import { Delete, Edit } from "@mui/icons-material";
import {
  oneLineText,
  sxSimpleTableStyle,
  sxTableActionButtonBorder,
  sxTableActionButtonBorderRed,
  sxTableHeadBG,
  sxTableRowLastChildBorderNoneStyle,
} from "../../../theme/globalStyles";
import TimeFormat from "../../../utils/timeFormat";
import StatusView from "../../ui/StatusView";

export default function AmaliatCategoryTable({
  allAmaliatCategories,
  deleteAmaliatCategory,

  can_update,
  can_delete,
  pageNo,
  rowsPerPage
}) {
  const navigate = useNavigate();
  return (
    <TableContainer>
      <Table
        sx={sxSimpleTableStyle({ px: 12, py: 12 })}
        aria-label="simple table"
      >
        <TableHead sx={{ ...sxTableHeadBG, oneLineText }}>
          <TableRow sx={oneLineText}>
            <TableCell>ID</TableCell>

            <TableCell>Title</TableCell>

            <TableCell>Sub-Title</TableCell>
            <TableCell>Sort Order</TableCell>

            <TableCell align="center">Active</TableCell>

            <TableCell align="center">Created At</TableCell>

            {(can_delete || can_update) && (
              <TableCell align="center">Actions</TableCell>
            )}
          </TableRow>
        </TableHead>

        <TableBody>
          {allAmaliatCategories?.map((amaliatCategory, index) => (
            <TableRow
              key={amaliatCategory.id}
              sx={sxTableRowLastChildBorderNoneStyle}
            >
              <TableCell>
                {pageNo > 0 ? pageNo * rowsPerPage + (index + 1) : index + 1}
              </TableCell>
              {/* title property */}
              <TableCell>{amaliatCategory.title ?? ""}</TableCell>

              {/* subtitle property */}
              <TableCell>{amaliatCategory.subTitle ?? ""}</TableCell>
              <TableCell>{amaliatCategory.sortOrder ?? "N/A"}</TableCell>

              {/* active property */}
              <TableCell>
                <StatusView
                  item={amaliatCategory.active}
                  compareValue={true}
                  valueMatched={"Yes"}
                  valueUnMatched={"No"}
                  center={true}
                />
              </TableCell>

              {/* created at */}
              <TableCell
                align="center"
                sx={{ ...oneLineText, padding: "0 20px !important" }}
              >
                {TimeFormat(amaliatCategory.creationDateTimeStamp)}
              </TableCell>

              {/* action property */}
              <TableCell align="center">
                <Stack direction={"row"} gap={1} justifyContent="center">
                  {/* view a amaliatCategory */}

                  {/* view a Amaliat */}
                  <Tooltip title="View Amaliyat" arrow>
                    <Button
                      sx={{
                        ...sxTableActionButtonBorder,
                        borderRadius: "30px",
                      }}
                      onClick={() =>
                        navigate(
                          `/amaliat/amaliat-category/${amaliatCategory?.id}/sub-category`
                        )
                      }
                    >
                      <IconButton>
                        <SubdirectoryArrowRightIcon />
                      </IconButton>
                    </Button>
                  </Tooltip>

                  {can_delete || can_update ? (
                    <>
                      {/* update amaliat label content */}
                      {can_update && (
                        <Tooltip title="Edit This Amaliyat Category" arrow>
                          <IconButton
                            color="primary"
                            variant="outlined"
                            sx={{ ...sxTableActionButtonBorder, width: "auto", height: "100%" }}
                            onClick={() =>
                              navigate(
                                `/amaliat/amaliat-category/edit/${amaliatCategory.id}`
                              )
                            }
                          >
                            <Edit />
                          </IconButton>
                        </Tooltip>
                      )}

                      {/* delete a Amaliat Category */}
                      {can_delete && (
                        <Tooltip title="Delete This Amaliyat Category" arrow>
                          <IconButton
                            color="error"
                            sx={{ ...sxTableActionButtonBorderRed, width: "auto", height: "100%" }}
                            onClick={() =>
                              deleteAmaliatCategory(amaliatCategory.id)
                            }
                          >
                            <Delete />
                          </IconButton>
                        </Tooltip>
                      )}
                    </>
                  ) : null}
                </Stack>
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
